import { useParams } from "react-router-dom";
import confirmDialog from "utils/confirmationDialog";

const { CommonSelect } = require("components/Common/Common");
const { useClientsServiceStatusListQuery } = require("store/services/utility");

const ServiceStatusUpdateField = ({ clientDetails, updateClient, clientType }) => {
  const { id: clientId} = useParams();

  //  Service status lookup
  const { data: serviceStatusList, isLoading: serviceStatusListLoading } = useClientsServiceStatusListQuery({ module: "client_service", client_type: clientType });
  const serviceStatusOptions = serviceStatusList?.map(i => ({ value: i.id, label: i.title }));

  const handleUpdateClient = (field) => async (value) => {
    try {
      let confirm = await confirmDialog({ type: "update" });
      if(!confirm) {
        return;
      }
      
      const payload = {
        [field]: value
      }
      await updateClient({ id: clientId, payload }).unwrap();
    } catch(err) { 
      console.error("Error updating client", err);
    }
  }

  return (
    <CommonSelect
      placeholder={"Please Select"}
      option={serviceStatusOptions}
      isLoading={serviceStatusListLoading}
      onChange={(status) => handleUpdateClient("service_status")(status.value) }
      value={clientDetails?.client_detail?.service_status ? serviceStatusOptions?.find(x => x.value === clientDetails?.client_detail?.service_status) : null}
    />
  )
}

export default ServiceStatusUpdateField;